<template>
  <div class="bg-white rounded-lg p-3 text-center color-main font-bold">
            <div class="font-lg">
                KẾT QUẢ SƠ DUYỆT
            </div>
            <div class="mt-3">
                <img class="m-auto text-center" src="@/assets/default/accept.png" >
            </div>
            <div class="mt-3">
                Xin chúc mừng!
            </div>
            <div>
                Đã tìm thấy khoản vay phù hợp với bạn tại {{partner}}
            </div>
             <div class="mt-3">
                <img class="m-auto text-center h-24" :src="logo"  >
            </div>
           
            <div class="border-input rounded-md bg-red-100">
                <div class="  text-lg ">
                    <div class=" p-2 rounded-md">
                        Số tiền vay: <span class="color-main2"> {{money}} triệu đồng </span> 
                    </div>
                </div>
                <div class="  text-lg">
                
                    <div class=" p-2 rounded-md">
                        Kỳ hạn: <span class="color-main2">12- 24 tháng</span>
                    </div>
                </div>
            </div>
            <div class="w-3/4 m-auto mt-4">
                Đối tác <span class="color-main2"> {{partner}} </span> sẽ liên hệ hỗ trợ bạn trong thời gian sớm nhất
            </div>
            <div class="w-3/4 text-xs m-auto mt-3">
                <i> Gọi số <span class="color-main2"> 1900633337 </span> nếu bạn chưa được liên hệ </i>
            </div>
        </div>
</template>

<script>
import { getMoney, getPartner, getLogo } from '@/utils/auth'

export default {
    data() {
        return {
            partner: getPartner(),
            money: getMoney(),
            logo: getLogo()
        }
    },
}
</script>

<style>

</style>